import { Wrapper } from './styles'

const Backdrop = ({ onClick }) => <Wrapper onClick={ onClick } />

export default Backdrop


